/* eslint-disable prefer-const */
/* eslint-disable object-shorthand */

import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Footer from '~/components/Footer';
import Menu from '~/components/Menu';
import { Container } from '~/styles/pagesStyle';
import { handleRegisterPage } from '../PaginasServices';
import CadastroCard from './CadastroCard';

const initialForm = {};

function PaginaCadastro() {
  const history = useHistory();
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    if (!form.nome) {
      toast.error('Nome da página é obrigatório');
      return;
    }
    if (!form.idSituacaoCadastral) {
      toast.error('Situação cadastral é obrigatório');
      return;
    }
    e.preventDefault();
    setLoading(true);
    const date = new Date().toISOString();
    const usuario = sessionStorage.getItem('@auth/userName');
    let page = {
      id: 0,
      nome: form.name,
      idSituacaoCadastral: form.idSituacaoCadastral,
      dataInclusao: date,
      usuario: usuario,
      excluido: true,
    };
    await handleRegisterPage(page, setLoading);
    history.push('/page/list');
  }

  return (
    <Container>
      <Footer />
      <Menu />
      <CadastroCard
        handleSubmit={handleSubmit}
        loading={loading}
        setForm={setForm}
        form={form}
      />
    </Container>
  );
}

export default PaginaCadastro;
